import { createStyles, Theme } from "@material-ui/core";

export const RequestDetailStyle = (theme: Theme) =>
  createStyles({
    requestDialogContainer: {
      "& .dialogContent": {
        overflowY: "initial",
      },
      "& .perfectScrollbar": {
        overflow: "initial !important",
      },
    },
    disabledSection: {
      opacity: 0.5,
      pointerEvents: "none",
    },
    font16:{
      fontSize: 16,
      marginBottom: 10,
    },
    placeholderFont:{
      '&>:first-child':{
        '&>:first-child':{
          '& .Font14':{
            fontSize: 14,
          }
        }
      }
    },
    // calendar
    customCalendar:{
      '&>:first-child':{
        width: '100%!important'
      },
      '& .rdrCalendarWrapper':{
        width: 'auto'
      },
      '& input':{
        paddingRight: 0
      }
    },
    greyText:{
      color: '#999',
      fontSize: 14,
      opacity: 1,
    },
    whiteCard: {
      background: "#FFF",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      borderRadius: 4,
      padding: "16px 20px",
      marginBottom: 20,
      "& ::placeholder": {
        color: "#999",
        fontSize: 14,
        opacity: 1,
      },
    },
    mainHeading: {
      fontWeight: 600,
      fontSize: 20,
      color: "#333",
    },
    inputLabel: {
      fontSize: 16,
      color: "#333",
      marginBottom: 10,
      marginTop: 32,
    },
    whitecardContainer: {
      margin: "14px 0",
    },
    customInput: {
      // marginBottom: 20,
      "&>:first-child": {
        width: "100%",
      },
    },
      dialogContainer:{
        width: "100%",
        padding: "26px 30px 0 30px",
        minWidth: 750,
        // maxHeight: 350,
        // minHeight: 150,
        overflow: 'visible',
        '&>:nth-child(1)': {
          '& .optionContainer': {
            bottom: 'initial',            
          },
          '&>:nth-child(2)':{
            '&>:nth-child(2)': {
              '&:after': {
                bottom:0,
                top: '-6px !important',
                transform: "rotate(226deg) !important",
              }
            }
          }          
        },
        '&>:nth-last-child(2)': {
          '& .optionContainer': {
            bottom: 60,            
          },
          '&>:nth-child(2)':{
            '&>:nth-child(2)': {
              '&:after': {
                bottom:54,
                top: 'initial !important',
                transform: "rotate(45deg) !important",
              }
            }
          }          
        },
        '& .customFooter': {
          // position: "absolute",
          // bottom:0,
          // zIndex:999,
          // left:0,
          // right:0,
          // background: "rgb(255 255 255)",
          // padding: "12px 24px 0",
          // borderTop: "solid 1px rgb(226 226 226)",
        },
        '& .iconImage': {
          width: 30,
          height: 30,
          padding: 5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          '&>div:nth-of-type(1)':{
            width: 30,
            height: 30,
            fontSize: 16,
          }
        },
        '& .searchContainer': {
          margin: '12px 0px',
          position: 'relative',
          '& img':{
            position: 'absolute',
            left: '10px',
            top: '8px',
            width: '20px',
            marginRight: '10px',
          },
          '& input':{
            border: '0.5px solid #DFDFDF',
            borderRadius: '4px',
            padding: '10px 10px 10px 40px',
            width: '100%',
          },
        },
        "&::before": {
          display: "none",
        },
      },
    
    textField: {
      width: "100%",
      "&>:first-child": {
        "&>:first-child": {
          "&>:first-child": {
            border: "1px solid #dfdfdf",
            borderRadius: 4,
            padding: 10,
            paddingLeft: 16,
          },
        },
        "&::before": {
          display: "none",
        },
      },
    },
    RequestOwner: {
      borderRadius: 4,
      border: "1px solid #dfdfdf",
      padding: "12px 16px",
      width: "100%",
      height: 40,
      lineHeight: "14px",
      position: "relative",
    },
    plusIcon: {
      position: "absolute",
      right: 12,
      cursor: "pointer",
    },
    placeholderTxt: {
      color: "#999",
      fontSize: 14,
    },
    AddedText: {
      fontSize: 14,
    },
    EditLink: {
      color: "#1d7dea",
      fontSize: 14,
      textDecoracion: "underline",
    },
    requestCardElement: {
      marginBottom: 16,
      "& .subjectLabel": {
        height: 26,
      },
    },
    searchContainer: {
      position: "relative",
      width: "100%",
      "& img": {
        position: "absolute",
        left: "10px",
        top: "8px",
        width: "20px",
        marginRight: "10px",
      },
      "& input": {
        border: "0.5px solid #DFDFDF",
        borderRadius: "4px",
        padding: "10px 10px 10px 40px",
        width: "100%",
      },
    },
    mt2x: {
      marginTop: "20px",
    },
    requestDialogTitle: {
      fontWeight: 600,
      fontSize: 24,
      lineHeight: "33px",
      color: "#333333",
    },
    dialogActions: {
      margin: "10px 0",
      "& button": {
        minWidth: "100px",
      },
    },
    SubHeading: {
      "& img": {
        verticalAlign: "bottom",
        marginRight: 12,
      },
      "& span": {
        fontSize: 16,
        color: "#333",
        fontWeight: 600,
      },
    },
    mb32: {
      marginBottom: 14,
    },
    mt15:{
      marginTop: 15,
    },
    dropDownWidth: {
      "&>:first-child": {
        "&>:first-child": {
          maxWidth: "100%",
        },
        "&>:nth-child(2)": {
          width: "100%",
        },
      },
    },
    secHeading: {
      fontSize: 20,
      color: "#999",
      marginBottom: 20,
    },
      purple: {		
        border: 'solid 1px #78d2a7',
        background: 'rgb(255 255 255)',
        width: '25px',
        height: '25px',
        fontSize: '10px',
        color: '#1d7dea'	
      },
      disableInput:{
        pointerEvents: "none",
        backgroundColor: "#f6f6f6",
        borderRadius: 4,
      },
      grayScale:{
        filter:'grayScale'
      } 
  });
